import { Component, Output, Input, EventEmitter } from '@angular/core';
import { MatterDispatch } from '@state/matter';
import { MatterFields } from '@models/matter';
import { Store } from '@ngxs/store';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { TestHooks } from './agreement-date.hooks';
import { AI_GENERATED_ICON } from '@core/util/icon';
import { tap, map } from 'rxjs/operators';

@Component({
	selector: 'app-sale-agreement-date',
	templateUrl: './agreement-date.component.html',
	standalone: false,
})
export class AgreementDateComponent {
	testHooks = TestHooks;
	private closingDate: string;
	private agreementDate: string;
	public AI_ICON = AI_GENERATED_ICON.icon;
	public AI_TOOLTIP = AI_GENERATED_ICON.tooltip;
	public AI_CLASSES = AI_GENERATED_ICON.classes;

	@Input() skeletonLoading = false;
	@Output() onFocus = new EventEmitter<string>();

	public closingDate$ = this.store.select(SelectedMatter.closingDate).pipe(
		tap((date) => {
			this.closingDate = date;
		}),
	);

	public agreementDateMappings$ = this.store
		.select(SelectedMatter.getFieldMappings)
		.pipe(map((mappings) => mappings?.agreementDate));

	public agreementDate$ = this.store.select(SelectedMatter.agreementDate).pipe(
		tap((date) => {
			this.agreementDate = date;
		}),
	);
	public field = MatterFields.AGREEMENT_DATE;

	constructor(
		private matterDispatch: MatterDispatch,
		private store: Store,
	) {}

	_onFocus(): void {
		this.onFocus.emit(this.field);
	}

	onChange = (event: string): void => {
		if (
			this.agreementDate !== event &&
			(!event || !this.closingDate || this.closingDate >= event)
		) {
			this.matterDispatch.OverwriteFields('agreementDate', event);
		}
	};
}
